import { type FormEvent, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { useApp } from "../context/AppContext";
import { api } from "../lib/api";

const sectors = [
  ["formation", "Formation"], ["btp", "Bâtiment et travaux publics"],
  ["transport", "Transport"], ["garage", "Garage automobile"],
  ["restauration", "Restauration et boulangerie"], ["clinique", "Clinique"],
  ["hotel", "Hôtellerie"], ["immobilier", "Immobilier"],
  ["agriculture", "Agriculture"], ["ong", "ONG et programmes"], ["autre", "Autre activité"]
];
const countries = [
  ["ML", "Mali"], ["BF", "Burkina Faso"], ["NE", "Niger"], ["CI", "Côte d'Ivoire"],
  ["SN", "Sénégal"], ["TG", "Togo"], ["BJ", "Bénin"], ["GN", "Guinée"]
];

export function CreateBusinessPage() {
  const { bootstrap, switchOrganisation } = useApp();
  const navigate = useNavigate();
  const [submissionId] = useState(() => crypto.randomUUID());
  const [form, setForm] = useState({ company: "", phone: "", country_code: "ML", sector: "autre" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const result = await api.post<{ organisation: { code: string }; created: boolean }>("/api/v1/auth/oidc/business/create/", {
        ...form,
        submission_id: submissionId,
        landing_page: window.location.origin + "/create-business",
        source: "platform",
        locale: "fr"
      }, null);
      await switchOrganisation(result.organisation.code);
      navigate("/", { replace: true });
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Création de l'entreprise impossible.");
    } finally {
      setBusy(false);
    }
  }

  return <main className="min-h-screen bg-slate-50 px-5 py-14">
    <div className="mx-auto max-w-xl rounded-2xl bg-white p-7 shadow-sm">
      <img src="/saheltech-mark.svg" alt="SahelTech" className="h-12 w-auto" />
      <h1 className="mt-7 text-3xl font-black text-slate-950">Créer une entreprise</h1>
      <p className="mt-3 text-sm text-slate-600">Chaque entreprise possède ses propres équipes, données, modules et abonnement. Votre compte SahelTech reste unique.</p>
      {Boolean(bootstrap?.organisations?.length) && <Link to="/entreprises" className="mt-4 inline-block text-sm font-semibold text-emerald-700 hover:underline">Retour à mes entreprises</Link>}
      <form className="mt-7 space-y-5" onSubmit={submit}>
        <label><span className="label">Nom de l’entreprise</span><input className="field" required maxLength={200} value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} /></label>
        <label><span className="label">Téléphone professionnel</span><input className="field" required maxLength={64} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} /></label>
        <label><span className="label">Pays</span>
          <select className="field" value={form.country_code} onChange={(e) => setForm({ ...form, country_code: e.target.value })}>
            {countries.map(([code, name]) => <option key={code} value={code}>{name}</option>)}
          </select>
        </label>
        <label><span className="label">Secteur d’activité</span>
          <select className="field" value={form.sector} onChange={(e) => setForm({ ...form, sector: e.target.value })}>
            {sectors.map(([code, name]) => <option key={code} value={code}>{name}</option>)}
          </select>
        </label>
        {error && <p role="alert" className="rounded-xl bg-amber-50 p-4 text-sm text-amber-900">{error}</p>}
        <button className="btn-primary w-full" disabled={busy}>{busy ? "Création en cours…" : "Créer mon espace SahelTech"}</button>
      </form>
    </div>
  </main>;
}
